export const FETCH_NEWSLETTER = 'FETCH_NEWSLETTER'
export const FETCH_NEWSLETTER_SUCCESS = 'FETCH_NEWSLETTER_SUCCESS'
export const FETCH_NEWSLETTER_FAILS = 'FETCH_NEWSLETTER_FAILS'

export const DOWNLOAD_NEWSLETTER_CSV = 'DOWNLOAD_NEWSLETTER_CSV'
export const DOWNLOAD_NEWSLETTER_CSV_SUCCESS = 'DOWNLOAD_NEWSLETTER_CSV_SUCCESS'
export const DOWNLOAD_NEWSLETTER_CSV_FAILS = 'DOWNLOAD_NEWSLETTER_CSV_FAILS'